/*
 * Share of each constituent group that must respond before a report can run.
 * fsci-api enforces the same numbers in ReportService.matchesProportions.
 */
export const MINIMUM_THRESHOLDS: Record<ConstituencyGroup, number> = {
    students: 0.4,
    teachers: 0.6,
    administrators: 0.6,
    supportStaff: 0.6,
    parents: 0.2,
    alumni: 0.2,
    boardMembers: 0.6,
};

export const minimumResponses = (group: ConstituencyGroup, groupSize: number): number =>
    Math.ceil(groupSize * MINIMUM_THRESHOLDS[group]);
